import React, { useEffect, useState } from "react";
import "../styles/ForYou.css";

import { useAuth } from "../context/AuthContext";
import { db } from "../firebase";

import {
  collection,
  query,
  where,
  orderBy,
  limit,
  onSnapshot,
  doc,
  updateDoc,
} from "firebase/firestore";

import { useNavigate } from "react-router-dom";

import {
  FaShoppingCart,
  FaTaxi,
  FaMotorcycle,
  FaWallet,
  FaHeart,
  FaStore,
  FaBullhorn,
  FaNewspaper,
  FaBriefcase,
  FaTimes,
} from "react-icons/fa";

export default function ForYou() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [activities, setActivities] = useState([]);

  useEffect(() => {
    if (!user) {
      setActivities([]);
      return;
    }

    console.log("Logged in UID:", user.uid);

    const q = query(
      collection(db, "activity"),
      where("uid", "==", user.uid),
      orderBy("createdAt", "desc"),
      limit(50)
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        console.log("Activities Found:", snapshot.size);

        const now = Date.now();

        // 48 hours in milliseconds
        const fortyEightHours = 48 * 60 * 60 * 1000;

        const data = snapshot.docs
          .map((activityDoc) => ({
            id: activityDoc.id,
            ...activityDoc.data(),
          }))
          .filter((item) => {

            // Already dismissed
            if (item.read === true) {
              return false;
            }

            // No createdAt
            if (!item.createdAt?.toDate) {
              return true;
            }

            const createdTime =
              item.createdAt.toDate().getTime();

            const age =
              now - createdTime;

            // Show only notifications
            // created within the last 48 hours
            return age < fortyEightHours;
          });

        console.log(
          "Active activities:",
          data
        );

        setActivities(data);
      },
      (error) => {
        console.error(
          "Firestore Error:",
          error
        );
      }
    );

    return unsubscribe;
  }, [user]);


  // =====================================================
  // ICON
  // =====================================================

  const getIcon = (type) => {

    switch (type) {

      case "shop_order":
      case "order_placed":
        return <FaShoppingCart />;

      case "ride_request":
      case "ride_accepted":
      case "ride_completed":
      case "ride_booked":
        return <FaTaxi />;

      case "delivery_request":
      case "delivery_completed":
        return <FaMotorcycle />;

      case "wallet_credit":
      case "wallet_debit":
        return <FaWallet />;

      case "post_like":
      case "post_comment":
        return <FaHeart />;

      case "shop_approved":
        return <FaStore />;

      case "local_update":
        return <FaNewspaper />;

      case "job":
        return <FaBriefcase />;

      default:
        return <FaBullhorn />;
    }
  };


  // =====================================================
  // BORDER
  // =====================================================

  const getBorder = (priority) => {

    switch (priority) {

      case "high":
        return "#ef4444";

      case "medium":
        return "#f59e0b";

      default:
        return "#2563eb";
    }
  };


  // =====================================================
  // DISMISS
  // =====================================================

  const handleDismiss = async (
    e,
    activityId
  ) => {

    e.stopPropagation();

    try {

      await updateDoc(
        doc(db, "activity", activityId),
        {
          read: true,
        }
      );

      setActivities((prev) =>
        prev.filter(
          (item) =>
            item.id !== activityId
        )
      );

    } catch (error) {

      console.error(
        "Error dismissing activity:",
        error
      );
    }
  };


  // =====================================================
  // PAGE
  // =====================================================

  return (

    <div className="foryou-page">

      <h2>✨ For You</h2>

      {activities.length === 0 ? (

        <div className="empty-card">
          Nothing for you yet.
        </div>

      ) : (

        activities.map((item) => (

          <div
            key={item.id}
            className="activity-card"
            style={{
              borderLeft:
                `5px solid ${getBorder(
                  item.priority
                )}`,
            }}
            onClick={() => {

              if (item.action) {
                navigate(item.action);
              }

            }}
          >

            <div className="activity-icon">

              {getIcon(item.type)}

            </div>


            <div className="activity-content">

              <h4>
                {item.title}
              </h4>

              <p>
                {item.message}
              </p>

              {item.createdAt?.toDate && (

                <small>

                  {item.createdAt
                    .toDate()
                    .toLocaleString()}

                </small>

              )}

            </div>


            <button
              type="button"
              className="activity-close"
              onClick={(e) =>
                handleDismiss(
                  e,
                  item.id
                )
              }
              aria-label="Dismiss"
            >

              <FaTimes />

            </button>

          </div>

        ))

      )}

    </div>
  );
}